import React from 'react';
/* eslint-disable */
import { Row, Checkbox, Collapse } from 'antd';
/* eslint-disable */
import { CaretRightOutlined } from '@ant-design/icons';
import './styles.less';
import { PropTypes } from 'prop-types';
/* eslint-disable */
import { Col } from 'antd/es';

const { Panel } = Collapse;

const FormInvestorProfileResume = ({ selectProducts }) => {
  return (
    <>
      <Row>
        <Col span={24} className="formInvestorProfile__title">
          Resumen de productos.
        </Col>
      </Row>

      <Collapse
        className="contract__body__collapse"
        defaultActiveKey={['1', '2', '3', '4']}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      >
        <Panel
          header="Vantrust Corredora de Bolsa S.A"
          className="formInvestorProfile__subTitle"
          key="1"
        >
          {selectProducts.indexOf(1) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" checked>
                Sólo compra/venta de moneda extranjera - SPOT
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}

          {selectProducts.indexOf(2) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={2} readonly checked>
                Renta Variable Nacional
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(3) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={3} readonly checked>
                Compra/venta a plazo (simultánea)
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(4) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={4} readonly checked>
                Renta Fija e Intermediación Financiera
                <ul>
                  <li>Intermediación en Renta Fija Local</li>
                  <li>Bonos</li>
                  <li>Depósitos a plazo</li>
                </ul>
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(5) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={5} readonly checked>
                Administración de Cartera
                <ul>
                  <li>Renta Fija Internacional en DCV</li>
                  <li>Bonos</li>
                  <li>Renta Variable Internacional en DCV</li>
                </ul>
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
        </Panel>
        <Panel header="Inversiones VNT S.A" className="formInvestorProfile__subTitle" key="2">
          {selectProducts.indexOf(6) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={6} readonly checked>
                Nota Estructuradas
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(7) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={7} readonly checked>
                Capital Preferente
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(8) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={8} readonly checked>
                Fondos Financieros{' '}
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(9) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={9} readonly checked>
                Moneda Extranjera Forward
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
        </Panel>
        <Panel
          header="Vantrust Gestión Patrimonial S.A"
          className="formInvestorProfile__subTitle"
          key="3"
        >
          {selectProducts.indexOf(10) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={10} readonly checked>
                Fondos Financieros
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
          {selectProducts.indexOf(11) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={11} readonly checked>
                Fondos de Renta Inmobiliaria / Desarrollo Inmobiliario
              </Checkbox>
            </Col>
          ) : (
            <Row direction="vertical"> </Row>
          )}
        </Panel>

        <Panel
          header="Vantrust Administradora General de Fondos S.A"
          className="formInvestorProfile__subTitle"
          key="4"
        >
          {selectProducts.indexOf(12) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={12} readonly checked>
                Fondos Públicos
              </Checkbox>
            </Col>
          ) : (
            ''
          )}
          {selectProducts.indexOf(13) !== -1 ? (
            <Col span={24} direction="vertical">
              <Checkbox className="resumen" value={13} readonly checked>
                Fondos Privados
              </Checkbox>
            </Col>
          ) : (
            ''
          )}
        </Panel>
      </Collapse>
    </>
  );
};

FormInvestorProfileResume.propTypes = {
  selectProducts: PropTypes.string.isRequired,
};

export default FormInvestorProfileResume;
